export default function LikeIcon({isLiked = false, shouldWhite = false}) {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill={isLiked ? '#3F621A' : shouldWhite ? 'none' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16112 2.61383C7.495 0.665984 4.71662 0.14202 2.62908 1.92566C0.541533 3.7093 0.247636 6.69146 1.88699 8.80098C3.25001 10.5549 7.37497 14.2541 8.72691 15.4513C8.87817 15.5853 8.95379 15.6523 9.04201 15.6786C9.119 15.7016 9.20325 15.7016 9.28024 15.6786C9.36845 15.6523 9.44408 15.5853 9.59533 15.4513C10.9473 14.2541 15.0722 10.5549 16.4352 8.80098C18.0746 6.69146 17.8166 3.69054 15.6932 1.92566C13.5697 0.160782 10.8272 0.665984 9.16112 2.61383Z"
        stroke={shouldWhite ? isLiked ? "#3F621A" : '#fff' : '#3F621A'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}